export default __webpack_public_path__ + "static/media/LO16.b6c4a2d9.mp3";